export const buttonMuiVariantMap = variant => {
  switch (variant) {
    case 'secondary':
      return 'outlined';
    case 'tertiary':
      return 'text';
    default:
      return 'contained';
  }
};
export const buttonMuiSizeMap = size => {
  if (size === 'large' || size === 'lg') return 'large';
  if (size === 'small' || size === 'sm') return 'small';
  return 'medium';
};